import { Directive, ElementRef, inject, input, OnChanges, SimpleChanges } from '@angular/core';
import mermaid from 'mermaid';
import { ThemeService } from "../../../services/theme.service";

@Directive({
  selector: '[appMermaid]',
  standalone: true,
})
export class MermaidDirective implements OnChanges {
  appMermaid = input<string>('');

  #themeService = inject(ThemeService);

  constructor(private el: ElementRef) {
    this.initializeMermaid();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appMermaid'] || changes['theme']) {
      this.renderMermaid();
    }
  }

  private initializeMermaid() {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'default',
      themeVariables: {
        primaryColor: '#00aaff',
        primaryTextColor: '#ffffff',
        primaryBorderColor: '#00aaff',
        lineColor: '#00aaff',
        secondaryColor: '#333',
        tertiaryColor: '#333',
      },
    });
  }

  private renderMermaid() {
    if (this.appMermaid()) {
      const elementId = 'mermaid-diagram-' + Math.floor(Math.random() * 10000); // Unique ID for each diagram
      this.el.nativeElement.innerHTML = `<div id="${elementId}">${this.appMermaid()}</div>`;

      mermaid.initialize({
        theme: this.#themeService.getTheme() === 'dark' ? 'dark' : 'default',
        themeVariables: this.#themeService.getTheme() === 'dark' ? {
          background: '#151515',
          primaryColor: '#00aaff',
          primaryTextColor: '#ffffff',
          primaryBorderColor: '#00aaff',
          lineColor: '#00aaff',
          secondaryColor: '#333',
          tertiaryColor: '#333',
        } : {
          primaryColor: '#00aaff',
          primaryTextColor: '#000000',
          primaryBorderColor: '#00aaff',
          lineColor: '#00aaff',
          secondaryColor: '#333',
          tertiaryColor: '#333',
        },
      });

      mermaid.run({
        querySelector: `#${elementId}`
      });

      // mermaid.init(undefined, `#${elementId}`);
    }
  }
}
